import { useEffect } from 'react';
import { refreshToken, logoutUser } from '../controller/userController'; // Ajusta ruta

export const useTokenRefresher = () => {
  useEffect(() => {
    // Función para refrescar token periódicamente
    const interval = setInterval(async () => {
      try {
        await refreshToken();
        console.log('Token refrescado correctamente');
      } catch (error) {
        console.error('Error refrescando token, cerrando sesión');
        logoutUser();
        // Aquí podrías forzar redirección a login si quieres
        window.location.href = '/login';
      }
    }, 15 * 60 * 1000); // 5 minutos en milisegundos

    return () => clearInterval(interval); // Limpia el intervalo al desmontar
  }, []);
};
